<template>
  <div class="mb-3">
  <p>登録します。<br>よろしいでしょうか。</p>
  </div>
  <div class="rental_contract_confirm_notice">
    スケジュール情報が「確認待ち」に更新されます。<br>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  setup() {
    return {};
  },
});
</script>
